import type { ServiceArea } from '../types/content';

export const serviceAreas: ServiceArea[] = [
  {
    city: 'Columbus',
    description: {
      en: 'Our home base on Cleveland Ave. We paint downtown offices and Short North storefronts, plus homes in Clintonville, Linden, German Village, and every Columbus neighborhood.',
      es: 'Nuestra sede en Cleveland Ave. Pintamos oficinas del centro y tiendas en Short North, además de casas en Clintonville, Linden, German Village y todos los barrios de Columbus.',
    },
  },
  {
    city: 'Dublin',
    description: {
      en: 'Corporate offices around Bridge Park and Metro Place, and interior and exterior house painting in Dublin neighborhoods.',
      es: 'Oficinas en Bridge Park y Metro Place, y pintura interior y exterior de casas en los vecindarios de Dublin.',
    },
  },
  {
    city: 'Westerville',
    description: {
      en: 'Uptown storefronts, schools, and churches — and family homes, decks, and fences across Westerville.',
      es: 'Tiendas de Uptown, escuelas e iglesias — y casas, terrazas y cercas en todo Westerville.',
    },
  },
  {
    city: 'Hilliard',
    description: {
      en: 'Warehouses along the I-270 corridor, plus whole-house and cabinet painting in Hilliard subdivisions.',
      es: 'Almacenes sobre el corredor I-270, además de pintura de casas y gabinetes en los vecindarios de Hilliard.',
    },
  },
  {
    city: 'Grove City',
    description: {
      en: 'Retail plazas and distribution centers, and exterior repaints for homes and townhomes in Grove City.',
      es: 'Plazas comerciales y centros de distribución, y pintura exterior de casas y townhomes en Grove City.',
    },
  },
  {
    city: 'Gahanna',
    description: {
      en: 'Offices and property-managed buildings, plus interior painting for homes and condos in Gahanna.',
      es: 'Oficinas y edificios administrados, además de pintura interior para casas y condominios en Gahanna.',
    },
  },
  {
    city: 'Reynoldsburg',
    description: {
      en: 'Restaurants, daycares, and churches — and room-by-room repaints for Reynoldsburg homeowners.',
      es: 'Restaurantes, guarderías e iglesias — y repintado por habitación para familias de Reynoldsburg.',
    },
  },
  {
    city: 'Worthington',
    description: {
      en: 'Old Worthington storefronts and offices, and careful painting for historic homes in Worthington.',
      es: 'Tiendas y oficinas de Old Worthington, y pintura cuidadosa para casas históricas en Worthington.',
    },
  },
];
